import { deserialize } from "libs/cerialize";

export class MessageDto {
    @deserialize
    Role: string;

    @deserialize
    Content: string;
}
